/**
 * Returns true if a key event targets an editable element (input, textarea,
 * select, or contenteditable). Global keydown listeners should bail out
 * before consuming a key when this is true, otherwise typing in a text
 * field will also trigger app shortcuts.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tagName = target.tagName.toLowerCase();
  return (
    tagName === "input" ||
    tagName === "textarea" ||
    tagName === "select" ||
    target.isContentEditable ||
    Boolean(target.closest("[contenteditable='true']"))
  );
}
